import { useMemo } from 'react';

import useGoogleMaps from '../providers/GoogleMaps/GoogleMaps.provider';

const useGoogleGeocoder = (): google.maps.Geocoder | null => {
  const { loaded } = useGoogleMaps();

  const geocoder = useMemo<google.maps.Geocoder | null>(() => {
    // Check if map script is initialized
    if (!window.google && !loaded) return null;

    return new google.maps.Geocoder();
  }, [window.google, loaded]);

  return geocoder;
};

export default useGoogleGeocoder;
